/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions
 */
export interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions
     */
    StoreSpecificOrderProductSku: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions(value: object): value is FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions {
    if (!('StoreSpecificOrderProductSku' in value) || value['StoreSpecificOrderProductSku'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'StoreSpecificOrderProductSku': json['StoreSpecificOrderProductSku'],
    };
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSONTyped(value?: FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'StoreSpecificOrderProductSku': value['StoreSpecificOrderProductSku'],
    };
}

